import { useConfig } from "../../../contexts/ConfigContext"
import { textNumberFormater } from "../../../utils"
import React, { useEffect, useState } from "react"
import { Dropdown, Popconfirm, TableColumnsType, Button } from "antd"
import { contentLayout, contentPath, modules } from "../../../config/pages"
import DataViewList from "../DataViewList"
import { useRegister } from "../../../contexts/RegisterContext"
import useAuth from "../../../hooks/useAuth"
import { useMovements } from "../../../hooks/useInventory"
import { useCompany } from "../../../contexts/CompanyContext"
import { MoreOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { useSecureRequest } from "../../../hooks/useSecureRequest"
import { movementStatus } from "../../../config/const"
import SelectMovementType from "../../common/SelectMovementType"
import { mutate } from "swr"

function ViewPendingExits(){
  const history = useHistory()
  const { config, updateConfig } = useConfig()
  const { register, updateRegister} = useRegister()
  const { company } = useCompany()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const {securePost} = useSecureRequest()
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data} = useMovements(tokenData,{
    company:company.current?.uid,
    module:config.module,
    pending: true,
    status:movementStatus.PENDING,
    documentType: register.currentMovementType
  })
  useEffect(()=>{
    if(tokenData && data?.movementList){
      updateRegister({pendingListExits:data.movementList})
      if(data.movementList.length){
        const matchedPending = register.currentPending?.uid
          ? data.movementList.find((m: any) => m.uid === register.currentPending.uid)
          : undefined
        const activePending = matchedPending || (register.currentPending?.uid ? register.currentPending : data.movementList[0])
        const itemList = activePending?.item_list || []
        console.log("items:", itemList)
        updateRegister({itemListExits:itemList, currentPending: activePending})
      }else{
        updateRegister({itemListExits:[]})
      }
      setSkeleton(false)
    }
  },[tokenData,data])

  let title = 'Movimientos pendientes por ejecutar'
  let emptyMessage = 'Aun no hay registros pendientes por ejecutar'
  
  const handleClick = async(data:any) => {
    console.log("Click sobre item: ",data)
    setSpinning(true)
    const orderResponse = await securePost('/inventory/movement/get-movement',{company: company.current?.uid,uidMovement: data.uid,module: config.module})
    setSpinning(false)
    if(orderResponse.status === 200){
      updateRegister({itemListExits: orderResponse.movement.item_list,currentPending:orderResponse.movement})
      updateConfig({forceModule:true,module:modules.RegisterExit,content:contentLayout[modules.RegisterExit]})
      history.push(contentPath[modules.RegisterExit])
    }else{
      alert("Ha ocurrido un error, por favor recargue la página e intente de nuevo")
    }
  }
  const menuItems = (record:any) => [
    {
      key: "1",
      label: (<button className="link-button" onClick={() => handleClick(record)}>Retomar salida</button>),
    },
    {
      key: "2",
      label: (
        <Popconfirm title="¡Esta seguro que desea eliminar este elemento?" onConfirm={() => deleteItem(record.uid)}>
          <span>Eliminar</span>
        </Popconfirm>
      ),
    },
  ];
  async function deleteItem(uid:string){
    setSpinning(true)
    const companyUid = company.current?.uid
    if(companyUid && uid){
      const newPendinglist = register.pendingListExits.filter(val => val.uid !== uid)
      await securePost("/inventory/movement/update-movement",{
        company: companyUid,
        uidOrder: uid,
        order: {
          status: movementStatus.CANCELLED
        },
        module: config.module
      })
      const isCurrentDeleted = register.currentPending?.uid === uid
      updateRegister({
        pendingListExits: newPendinglist,
        ...(isCurrentDeleted ? { currentPending: undefined, itemListExits: [] } : {})
      })
      mutate(
        (key: any) =>
          (typeof key === 'string' && key.includes('/inventory/movement/')) ||
          (Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement/')),
        undefined,
        { revalidate: true }
      )
    }
    setSpinning(false)
  }
  const rowMenu = (record:any) => {
    if(typeof record.key === "string"){
      return(<></>)
    }else{
      return(
        <Dropdown menu={{items:menuItems(record)}} trigger={['click']}>
          <button className="link-button" style={{ display: "block",width:"100%", justifyContent: "center",cursor:"pointer" }} onClick={(e) => e.stopPropagation()}>
            <MoreOutlined
              style={{ fontSize: "18px", cursor: "pointer" }}
            />
          </button>
        </Dropdown>
      )
    }
  }
  const tableColumns:TableColumnsType = [
    {title: "#",dataIndex:"register"},
    {title: "Registro",dataIndex:"code"},
    {title: "Items",dataIndex:"items"},
    {title: "Fecha creación",dataIndex:"created_at",render:(text)=>new Date(text).toLocaleString()},
    {title: "Total",dataIndex:"total_amount",render:(text)=><label className="numeric-values-data-table">{textNumberFormater(text)}</label>},
    {title:"Acciones",key:"actions",render:(_, record) => rowMenu(record)}
  ]

  const dataTable = register?.pendingListExits?.map((el:any,i:number)=>{
    el.code = el.document_number || el.uid
    el.register = i + 1
    el.key = i  
    return el
  })

  const currentMovementType = register.movementTypesExit.find(el => el.key === register.currentMovementType)
  if(!register.currentMovementType || !currentMovementType){
    return <SelectMovementType />
  }

  const headerElement = () => 
  <div style={{display:"flex",justifyContent:"flex-end"}}>
    <Button 
      type="link" 
      onClick={()=>updateRegister({currentMovementType:null})}
    >
      {`Cambiar tipo - ${currentMovementType.string_value}`}
    </Button>
  </div> 

  return (
    <DataViewList
      title={title}
      spinning={spinning}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      onRow={() => {}}
      emptyMessage={emptyMessage}
      headerElement={headerElement}>
    </DataViewList>
  )
}

export default ViewPendingExits